import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { AssertionFraudResult } from "@idw-types/data/assertion-fraud-result";

export const getAssertionFraudRequest = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: Array<AssertionFraudResult>, error: any }> => {
    const route = apiRoutes.reports.assertionFraud.results;

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};